import type { TodoResponse } from '@/api/types/todo'

/** メインリストと同じソート: position ASC → created_at DESC */
export const compareTodoPosition = (a: TodoResponse, b: TodoResponse): number => {
  const posA = a.position ?? 0
  const posB = b.position ?? 0
  if (posA !== posB) return posA - posB
  return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
}
